<div *ngIf="!config?.header_type" class="head-note-section" [ngClass]="{'head-note-section-1': !pan_updated && config?.order?.cart?.currency === 'INR' && config?.order?.campaign?.beneficiary?.tax_benefit && (!userData?.pan_number?.info_1 || !userData?.address_1)}">
  <div class="note" [ngClass]="{'justify-content-center': config?.v1 && !isMobile}">
    <img src="/assets/images/success-tick.png" alt="success-tick">
    <div class="text">
      <div class="heading">Contribution Successful</div>
      <div class="desc">Thank you {{config?.order?.donor_first_name?.trim()}} for contributing <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.donated_amount_local}}
        <span *ngIf="config?.order?.tip_amount_local"> + <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local}} {{config?.order?.pg_tax > 0 ? '(support fee)' :'(tip)'}}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!pan_updated && config?.order?.cart?.currency === 'INR' && config?.order?.campaign?.beneficiary?.tax_benefit && (!userData?.pan_number?.info_1 || !userData?.address_1)" class="tax-benefit-nudge" id="tax-nudge-typ">
    <app-component-loader [load]="true" [outputs]="{pan_updated: panUpdateToggle}" selector="app-tax-benefit-nudge"></app-component-loader>
  </div>
</div>


<div *ngIf="config?.header_type?.toString()?.match('v2')" class="head-section" [ngClass]="{'head-note-section-nudge': !pan_updated && config?.order?.cart?.currency === 'INR' && config?.order?.campaign?.beneficiary?.tax_benefit && (!userData?.pan_number?.info_1 || !userData?.address_1)}">
  <div class="note">
    <img src="/assets/images/success-tick-1.png" alt="success-tick">
    <div class="text" *ngIf="!config?.order?.bulkdonation">
      <div class="heading"><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.total_amount_charged | inrFormat:config?.order?.iso_currency}} contributed successfully!</div>
      <div class="desc">Thank you for contributing <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.donated_amount_local | inrFormat:config?.order?.iso_currency}} <span *ngIf="config?.order?.tip_amount_local"> + <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local | inrFormat:config?.order?.iso_currency}} {{config?.order?.pg_tax > 0 ? 'Support Fee.' :'Tip.'}}</span></strong></div>
      <div *ngIf="!config?.order?.is_multi_patient_campaign" class="desc">Keep supporting <strong>{{config?.order?.campaign?.beneficiaryname?.info_1.trim()}}.</strong></div>
      <div *ngIf="config?.order?.is_multi_patient_campaign" class="desc">Keep supporting <strong>{{config?.order?.sub_campaign?.beneficiaryname?.info_1.trim()}}.</strong></div>
    </div>
    <div class="text" *ngIf="config?.order?.bulkdonation">
      <div class="heading"><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.total_amount_charged | inrFormat:config?.order?.iso_currency}} contributed successfully!</div>
      <div class="desc">Thank you for contributing
        <strong>
          <div *ngFor="let item of config?.order?.bulkdonation; let i = index">
            <strong>
              <app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{item?.amount | inrFormat:config?.order?.iso_currency}} to {{item?.campaign?.beneficiaryname?.info_1.trim() || item?.campaign?.beneficiary?.full_name?.trim()}}{{i === config?.order?.bulkdonation?.length - 1 ? '.': ','}}
            </strong>
          </div>
        </strong>
      </div>
      <div class="desc">Keep supporting them</div>
    </div>
    <div *ngIf="!pan_updated && config?.order?.cart?.currency === 'INR' && config?.order?.campaign?.beneficiary?.tax_benefit && (!userData?.pan_number?.info_1 || !userData?.address_1)" class="tax-benefit-nudge" id="tax-nudge-typ">
      <app-component-loader [load]="true" [outputs]="{pan_updated: panUpdateToggle}" selector="app-tax-benefit-nudge"></app-component-loader>
    </div>
  </div>
</div>

<div *ngIf="config?.header_type?.toString()?.match('v3')" class="head-section" [ngClass]="config?.header_type">
  <div class="content">
    <div class="part-1">
      <div class="heading">Contribution Successful!</div>
      <div class="desc">We have recieved your generous contribution of <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.donated_amount_local | inrFormat:config?.order?.iso_currency}}</strong><span *ngIf="config?.order?.tip_amount_local"> and a {{config?.order?.pg_tax > 0 ? 'support fee' :'tip'}} of <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local | inrFormat:config?.order?.iso_currency}}</strong></span></div>
    </div>
    <div class="part-2">
      <mat-icon>check_circle</mat-icon>
    </div>
  </div>
</div>

<div *ngIf="config?.header_type?.toString()?.match('v4')" class="head-section" [ngClass]="config?.header_type">
  <div class="content">
    <img src="../assets/images/donation-confirmation-img.png" alt="">
    <div class="part-2">
      <div class="name">Thank you {{config?.order?.donor_first_name?.trim()}} !</div>
      <div class="sub">This generous {{config?.order?.pg_tax > 0 ? 'support fee' :'tip'}} of <strong><app-currency-icon [currency]="config?.order?.iso_currency"></app-currency-icon>{{config?.order?.tip_amount_local | inrFormat:config?.order?.iso_currency}}</strong> will help us to keep making the world better</div>
    </div>
  </div>
</div>

<div *ngIf="config?.header_type?.toString()?.match('v5')" class="head-section" [ngClass]="config?.header_type">
  <div class="content">
    <div class="circle">
      <div class="title">{{config?.userIntials}}</div>
      <img src="../assets/images/heartfilled.png" alt="">
    </div>
    <div class="sub">Hi {{config?.order?.donor_first_name?.trim()}}!</div>
  </div>
</div>
